const marks = [
    {
      value: 1,
      label: '1 min',
    },
    {
      value: 20,
      label: '20 min',
    },
    {
      value: 50,
      label: '50 min',  
    },
    {
      value: 120,
      label: '±120',
    },
  ];

  export default marks;